export default {"src":"https://cdn.jetlend.ru/_next/static/media/icon--star.320c6489.svg","height":15,"width":16,"blurWidth":0,"blurHeight":0};